import axios from 'axios';
export const createAxiosHttpClient = (baseURL) => {
    const axiosInstance = axios.create({
        baseURL,
    });
    return axiosInstance;
};
